export enum LoadStates {
    SELECT_PAYMENT,
    SUCCESS,
    FUEL_ERROR,
}